<div class="main-ncs-header-div">
  <div class="container d-flex align-items-center justify-content-between">
    <div class="logo-div" (click)="goHome()" style="cursor: pointer;">
      <img src="../../../assets/logo/ias-small-logo.png" alt="ias-logo" draggable="false">
      <h1>Indian Administrative Service <br>Central Association</h1>
    </div>
    <div class="navigationmenu d-flex align-items-center">
      <nav class="navbar navbar-expand-lg">
        <div class="container-fluid">
          <!-- Toggler (shows only below lg) -->
          <button class="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar"
            aria-controls="offcanvasNavbar">
            <span class="navbar-toggler-icon"></span>
          </button>

          <!-- Normal Navbar (visible on lg and up) -->
          <div class="collapse navbar-collapse d-none d-lg-flex" id="navbarNavAltMarkup">
            <div class="navbar-nav ms-auto">
               <a class="nav-link">About Us</a>
                <a class="nav-link">Office Bearers</a>
                <a class="nav-link">News & Events</a>
                <a class="nav-link">Gallery</a>
            </div>
          </div>

          <!-- Offcanvas (only visible on mobile/tablet) -->
          <div class="offcanvas offcanvas-start d-lg-none" tabindex="-1" id="offcanvasNavbar"
            aria-labelledby="offcanvasNavbarLabel">
            <div class="offcanvas-header">
              <h5 class="offcanvas-title" id="offcanvasNavbarLabel" (click)="goHome()">Website</h5>
              <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas"
                aria-label="Close"></button>
            </div>
            <div class="offcanvas-body">
              <div class="navbar-nav">

                <a class="nav-link">About Us</a>
                <a class="nav-link">Office Bearers</a>
                <a class="nav-link">News & Events</a>
                <a class="nav-link">Gallery</a>

             

              </div>
            </div>
          </div>
        </div>
      </nav>

    </div>
  </div>
</div>